import styled, { css } from 'styled-components';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_2_XL, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_SM, SYS_PAGE_MARGIN_XL, SYS_PAGE_MARGIN_XS, SYS_PAGE_MARGIN_2_XL, SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
export const StyledPopoverContainer = styled.div `
  line-height: 0;
`;
const popoverPadding = 16;
const defaultZIndex = 100000;
export const StyledPopover = styled.div `
  // TODO: Soon, page-margin will be available globally via falcon
  --page-margin: ${SYS_PAGE_MARGIN_XS};

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    --page-margin: ${SYS_PAGE_MARGIN_SM};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    --page-margin: ${SYS_PAGE_MARGIN_MD};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    --page-margin: ${SYS_PAGE_MARGIN_LG};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    --page-margin: ${SYS_PAGE_MARGIN_XL};
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    --page-margin: ${SYS_PAGE_MARGIN_2_XL};
  }

  position: fixed;
  z-index: ${(props) => props.zIndex ?? defaultZIndex};
  padding: ${SYS_SPACE_FIXED_200};
  background-color: ${(props) => props.theme.global.color.elevation.level3};
  box-shadow: ${(props) => props.theme.global.boxShadow.elevation.level3};
  will-change: filter;
  width: calc(100vw - ${2 * popoverPadding}px - 2 * var(--page-margin));
  max-width: calc(100vw - ${2 * popoverPadding}px - 2 * var(--page-margin));

  // TODO: Token Missing
  transition-property: opacity, transform;
  transition-duration: 125ms;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  opacity: ${(props) => props.state === 'entered' || props.state === 'entering' ? 1 : 0};
  transform: ${(props) => props.state === 'entered' || props.state === 'entering'
    ? 'translateY(0px)'
    : 'translateY(-20px)'};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: max-content;
  }

  ${(props) => props.withTip &&
    css `
      ::before {
        position: fixed;
        z-index: ${props.zIndex ? props.zIndex + 1 : defaultZIndex + 1};
        left: var(--tip-left);
        right: var(--tip-right);
        top: var(--tip-top);
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-left: 11.5px solid transparent;
        border-right: 11.5px solid transparent;
        filter: drop-shadow(0px -3px 2px rgba(0, 0, 0, 0.1));
        border-bottom: 11.5px solid
          ${(props) => props.theme.global.color.elevation.level3};

        ${props.placement === 'top' &&
        css `
          border-bottom: none;
          border-top: 11.5px solid
            ${(props) => props.theme.global.color.elevation.level3};
          filter: drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.1));
        `}
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map